var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "660px",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": !_vm.submitting,
        "append-to-body": "",
        "custom-class": "audit-config-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "audit-config-content",
        },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v("触发审核条件："),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "auditConfigFormRef",
              staticClass: "audit-config-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发卡类型：", prop: "sendTypes" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "config-field",
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.sendTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sendTypes", $$v)
                        },
                        expression: "form.sendTypes",
                      },
                    },
                    _vm._l(_vm.sendTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "充值总金额大于：",
                    prop: "rechargeAmountThreshold",
                  },
                },
                [
                  _c("el-input-number", {
                    staticClass: "config-field amount-input",
                    attrs: {
                      min: 0,
                      max: 9999999999.99,
                      step: 0.01,
                      precision: 2,
                      controls: false,
                      placeholder: "请输入",
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        return _vm.handleRechargeAmountKeydown($event)
                      },
                      paste: function ($event) {
                        return _vm.handleRechargeAmountPaste($event)
                      },
                    },
                    model: {
                      value: _vm.form.rechargeAmountThreshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "rechargeAmountThreshold", $$v)
                      },
                      expression: "form.rechargeAmountThreshold",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "section-title notice-title" }, [
                _vm._v("消息通知："),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "通知状态：", prop: "noticeStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.noticeStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "noticeStatus", $$v)
                        },
                        expression: "form.noticeStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.noticeStatus === 1
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "审核人飞书userID：",
                          prop: "auditorFeishuUserId",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "config-field",
                          attrs: {
                            maxlength: "255",
                            "show-word-limit": "",
                            clearable: "",
                            placeholder: "请输入",
                          },
                          model: {
                            value: _vm.form.auditorFeishuUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "auditorFeishuUserId", $$v)
                            },
                            expression: "form.auditorFeishuUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "提交人飞书userID：",
                          prop: "submitterFeishuUserId",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "config-field",
                          attrs: {
                            maxlength: "255",
                            "show-word-limit": "",
                            clearable: "",
                            placeholder: "请输入",
                          },
                          model: {
                            value: _vm.form.submitterFeishuUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "submitterFeishuUserId", $$v)
                            },
                            expression: "form.submitterFeishuUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "定时消息推送：", prop: "noticeTime" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "notice-time-row" },
                          [
                            _c("el-time-picker", {
                              staticClass: "config-field",
                              attrs: {
                                "value-format": "HH:mm:ss",
                                format: "HH:mm:ss",
                                placeholder: "请选择通知时间",
                              },
                              model: {
                                value: _vm.form.noticeTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "noticeTime", $$v)
                                },
                                expression: "form.noticeTime",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "time-unit" }, [
                              _vm._v("每天"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "config-description" }, [
            _c("div", { staticClass: "description-title" }, [_vm._v("说明：")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v("有新的申请会飞书通知设置的审核人，只支持配置一人。"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("有新的申请结果会飞书通知提交人，只支持配置一人。"),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("对于待审核数据，每天定时通知提交人、审核人进行追踪。"),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "", disabled: _vm.submitting },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.submitting,
                disabled: _vm.loading || _vm.submitting || !_vm.mode,
              },
              on: { click: _vm.debouncedSubmit },
            },
            [_vm._v(_vm._s(_vm.submitButtonText))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }